import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isNull from "lodash/isNull";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";

/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, BackButton, ColorBatch, Paper, Button, FileInput, showError, showSuccess } from 'components';
import { showApiError, convertToAdditionalCurrency } from 'utils';
import { getCredit, getDocumentForEarlyRepayment, signDocumentForCredit } from 'services';
import { creditsStatusName, creditStatusColorMap } from 'enums';
import { headerLeftTitle, headerLeftSubTitle, headerLeftId } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var documents_for_full_early_repayment = 'documents_for_full_early_repayment';

var EarlyRepaymentRequest = function EarlyRepaymentRequest(_ref) {
  var _location$state, _match$params, _creditData$borrower, _creditData$borrower2, _creditData$borrower3;

  var location = _ref.location,
      match = _ref.match,
      history = _ref.history;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      credit = _ref2.credit;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      creditId = _ref3.creditId;

  var _useState = useState(credit),
      _useState2 = _slicedToArray(_useState, 2),
      creditData = _useState2[0],
      setCreditData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      pdf = _useState4[0],
      setPdf = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSigned = _useState6[0],
      setIsSigned = _useState6[1];

  var fileInputRef = useRef();
  useEffect(function () {
    fetchCreditData();
    fetchDocument();
  }, []);

  var fetchCreditData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getCredit, _yield$getCredit2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCredit(creditId);

            case 2:
              _yield$getCredit = _context.sent;
              _yield$getCredit2 = _slicedToArray(_yield$getCredit, 2);
              res = _yield$getCredit2[0];
              err = _yield$getCredit2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setCreditData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), res);
              });
              setIsSigned(isSigned || res.signed_documents_for_full_early_repayment);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCreditData() {
      return _ref4.apply(this, arguments);
    };
  }();

  var fetchDocument = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$getDocumentFor, _yield$getDocumentFor2, res, err, url;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getDocumentForEarlyRepayment(creditId);

            case 2:
              _yield$getDocumentFor = _context2.sent;
              _yield$getDocumentFor2 = _slicedToArray(_yield$getDocumentFor, 2);
              res = _yield$getDocumentFor2[0];
              err = _yield$getDocumentFor2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              url = URL.createObjectURL(new File([res], 'document.pdf', {
                type: 'application/pdf'
              }));
              setPdf({
                url: url,
                isSign: false
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchDocument() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _fileInputRef$current;

      var fileData, formData, _yield$signDocumentFo, _yield$signDocumentFo2, res, err, url;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fileData = (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.value;

              if (!_isNull(fileData)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", showError('Моля, прикачете подписан документ!'));

            case 3:
              formData = new FormData();
              formData.append('file', fileData);
              _context3.next = 7;
              return signDocumentForCredit(creditId, formData, {
                type: documents_for_full_early_repayment
              });

            case 7:
              _yield$signDocumentFo = _context3.sent;
              _yield$signDocumentFo2 = _slicedToArray(_yield$signDocumentFo, 2);
              res = _yield$signDocumentFo2[0];
              err = _yield$signDocumentFo2[1];

              if (!err) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 13:
              url = URL.createObjectURL(new File([res], 'document.pdf', {
                type: 'application/pdf'
              }));
              setPdf({
                url: url,
                isSign: true
              });
              setIsSigned(true);
              showSuccess('Документът е подписан успешно!');

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmit() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleFinish = function handleFinish() {
    history.push({
      pathname: "/credits/details/".concat(creditId),
      state: {
        credit: creditData
      }
    });
  };

  var pdfWrap = {
    width: '100%',
    marginBottom: '1em'
  };
  var signWrap = {
    marginBottom: '1em'
  };
  var signLabel = {
    marginBottom: '0.5em',
    fontWeight: 500
  };
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.goBack();
    }
  }), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "\u041D\u043E\u043C\u0435\u0440: ", creditData === null || creditData === void 0 ? void 0 : creditData.number), ___EmotionJSX("h6", {
    css: headerLeftSubTitle
  }, "\u0421\u0443\u043C\u0430: ", creditData === null || creditData === void 0 ? void 0 : creditData.amount, " ", creditData === null || creditData === void 0 ? void 0 : creditData.currency, " /", convertToAdditionalCurrency({
    value: creditData === null || creditData === void 0 ? void 0 : creditData.amount,
    fromCurrency: creditData === null || creditData === void 0 ? void 0 : creditData.currency
  })), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower = creditData.borrower) === null || _creditData$borrower === void 0 ? void 0 : _creditData$borrower.first_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower2 = creditData.borrower) === null || _creditData$borrower2 === void 0 ? void 0 : _creditData$borrower2.middle_name, " ", creditData === null || creditData === void 0 ? void 0 : (_creditData$borrower3 = creditData.borrower) === null || _creditData$borrower3 === void 0 ? void 0 : _creditData$borrower3.last_name), ___EmotionJSX(ColorBatch, {
    type: creditStatusColorMap[creditData === null || creditData === void 0 ? void 0 : creditData.status],
    fontSize: "1rem",
    margin: "0 0 0 6px"
  }, creditsStatusName[creditData === null || creditData === void 0 ? void 0 : creditData.status])))), ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "0 2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: "\u0418\u0421\u041A\u0410\u041D\u0415 \u0417\u0410 \u041F\u0420\u0415\u0414\u0421\u0420\u041E\u0427\u041D\u041E \u041F\u041E\u0413\u0410\u0421\u042F\u0412\u0410\u041D\u0415",
    margin: "2em 0"
  }, ___EmotionJSX("div", {
    css: pdfWrap
  }, ___EmotionJSX("iframe", {
    title: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
    src: pdf === null || pdf === void 0 ? void 0 : pdf.url,
    width: "100%",
    height: "700px"
  })), !isSigned && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h5", {
    css: signLabel
  }, "\u041F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442:"), ___EmotionJSX("div", {
    css: signWrap
  }, ___EmotionJSX(FileInput, {
    ref: fileInputRef,
    fileFormat: true,
    accept: "image/*, application/pdf",
    formId: "file",
    label: "\u0418\u0437\u0431\u0435\u0440\u0438 \u0444\u0430\u0439\u043B",
    infoText: "\u041F\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u0438 - jpg, png, pdf \u043C\u0430\u043A\u0441. 30 MB!",
    id: "file",
    required: true,
    max: 30
  }))), ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: 12,
    justify: "flex-end"
  }, !isSigned ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return history.goBack();
    },
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
    onClick: handleSubmit
  }, "\u041F\u0440\u0438\u043A\u0430\u0447\u0438")) : ___EmotionJSX(Button, {
    type: "success",
    onClick: handleFinish
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438")))))));
};

EarlyRepaymentRequest.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};
export default EarlyRepaymentRequest;